import { baseUrl, headers, jwtHeaders } from '../common/data';

export const createConsumeProduct = async (data) => {

  const response = await fetch(`${baseUrl}/api/consumeableproduct/create`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const fetchAllConsumeProducts = async (branchId) => {
  const response = await fetch(
    `${baseUrl}/api/consumeableproduct/getconsumeableproductbybranch/${branchId}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    }
  );

  if (!response.ok) {
    throw new Error(`Error fetching consume products: ${response.status} ${response.statusText}`);
  }

  const resData = await response.json();
  return resData;
};

export const fetchConsumeProductById = async (productId, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/consumeableproduct/getconsumeableproduct/${productId}${branchId ? `?branchId=${branchId}` : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    }
  );

  const resData = await response?.json();
  return resData;
};

export const addConsumeableProductCount = async (productId, data, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/consumeableproduct/addconsumeableproductcount/${productId}${branchId ? `?branchId=${branchId}` : ''}`,
    {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: jwtHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to update consumeable product count');
  }

  const resData = await response?.json();
  return resData;
};

export const updateConsumeableProduct = async (productId, data, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/consumeableproduct/updateconsumeableproduct/${productId}${branchId ? `?branchId=${branchId}` : ''}`,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: jwtHeaders(),
    }
  );

  const resData = await response?.json();
  return resData;
};

export const deleteConsumeableProduct = async (id, branchId) => {
  const response = await fetch(`${baseUrl}/api/consumeableproduct/deleteconsumeableproduct/?branchId=${branchId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...jwtHeaders(),
    },
    body: JSON.stringify({
      ids: [id],
      status: false,
    })
  },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchServicesBillById = async (billId, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/getsinglebillservices/${billId}${branchId ? `?branchId=${branchId}` : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    }
  );

  const resData = await response?.json();
  return resData;
};

export const saveConsumedProducts = async (billId, branchId, data) => {
  const response = await fetch(
    `${baseUrl}/api/billing/consumedbillproduct/${billId}${branchId ? `?branchId=${branchId}` : ''}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...jwtHeaders(), // if you need auth headers
      },
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to save consumed products');
  }

  return await response.json();
};

export const createManyConsumeableProduct = async (branchId, data) => {
  const response = await fetch(`${baseUrl}/api/consumeableproduct/bulkUpload/${branchId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders()
  });
  const resData = await response?.json();
  return resData;
};







